const translations = {
  selectAssets: 'Seleção de ativos',
  'errors.loadAll': 'Erro ao buscar todos os ativos',
  'errors.loadAllMessage': 'Houve um problema ao carregar a lista completa de ativos.',
  'errors.load': 'Erro ao carregar ativos',
  'errors.loadMessage': 'Houve um problema ao carregar a lista de ativos.'
}

export default translations
